import React, { useState } from "react";
import { useSelector } from "react-redux";
import { getMainClasses } from "../../../shared/utils/userDetailsUtils";
import { selectEntitiesByFilters } from "../../../shared/store/views/entityView";
import { scheduleBoardMessagesQuery } from "../../../shared/utils/entitiesFiltersUtils";
import MiniWidget from "../../../shared/components/features/widget/miniWidget/MiniWidget";
import iconsList from "../../../shared/components/ui/icons/iconsList";
import Icon from "../../../shared/components/ui/icons/Icon";
import SchedulePopup from "../SchedulePopup/SchedulePopup";
import classes from "./SchedualMiniWidget.module.css";

const SchedualMiniWidget = ({ className, color = "#C5D7E4" }) => {

    const { texts } = useSelector(state => state.translate);
    const { userDetails } = useSelector(state => state.auth);
    const [popupOpen, setPopupOpen] = useState(false);
    const mainClasses = getMainClasses(userDetails);
    const scheduleEntities = useSelector((state) => selectEntitiesByFilters(state, scheduleBoardMessagesQuery));
    const hasSchedule = scheduleEntities?.length > 0;

    const openPopup = (e) => {
        e?.stopPropagation();
        setPopupOpen(true);
    };

    const closePopup = () => {
        setPopupOpen(false);
    };

    return (
        <>
            <MiniWidget color={color} onClick={openPopup} className={className}>
                {hasSchedule ?
                    <div className={classes.SchedualMiniWidgetWithImg}>
                        <div className={classes.SchedualMiniWidgetContent}>
                            <Icon name={iconsList.openImg} size={16} />
                        </div>
                        <p>{texts.scheduleMiniTitle}</p>
                    </div>
                    :
                    <div className={classes.SchedualMiniWidget}>
                        <div className={classes.SchedualMiniWidgetContent}>
                            <Icon name={iconsList.plusCircle} size={16} />
                        </div>
                        <p>{texts.scheduleMiniTitle}</p>
                    </div>
                }
            </MiniWidget>
            {popupOpen &&
                <SchedulePopup onClose={closePopup} mainClasses={mainClasses} />
            }
        </>
    );
};

export default SchedualMiniWidget;
